import React from 'react';

const ProductoCarro = (props) => {
	const carro_temp = props.carro.map((prod,i)=>{
		if(prod.cantidad>0){
			return <li className="list-group-item" key={i}>{prod.nombre}<h5 className="float-right">{prod.cantidad}</h5> </li>
		}
	})
	return(
  		<ul className="p-0 mt-3">
        	{ carro_temp &&
        		carro_temp
        	}
  		</ul>
	)
}

export default ProductoCarro;


// WEBPACK FOOTER //
// ./src/components/producto_carro.js